var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/16/arrow_up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64654 2.64645C7.8418 2.45118 8.15839 2.45118 8.35365 2.64645L11.5356 5.82843C11.7309 6.02369 11.7309 6.34027 11.5356 6.53553C11.3404 6.7308 11.0238 6.7308 10.8285 6.53553L8.5001 4.20711V13H7.5001V4.20711L5.17167 6.53553C4.97641 6.7308 4.65982 6.7308 4.46456 6.53553C4.2693 6.34027 4.2693 6.02369 4.46456 5.82843L7.64654 2.64645Z",
    fill: "#00A66A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.57f68fef84c197fc5486d6b7b1f586cf.svg";
export { ForwardRef as ReactComponent };